'use client';

import { c as _c } from "react/compiler-runtime";
import { Link } from "@heroui/react";
import { ArrowRight } from "lucide-react";
import { getContrastColor } from "@/util/color";
import { timeFromNow } from "@/util/dateUtils";
interface ArticleProps {
  title: string;
  slug: string;
  category: string;
  categoryColor: string;
  excerpt: string;
  imageUrl: string;
  publishedAt: Date;
}
export function LatestArticle(t0) {
  const $ = _c(43);
  const {
    title,
    category,
    excerpt,
    imageUrl,
    publishedAt,
    slug,
    categoryColor
  } = t0;
  let t1;
  if ($[0] !== imageUrl || $[1] !== title) {
    t1 = <img src={imageUrl} alt={title} className="w-full h-48 object-cover" />;
    $[0] = imageUrl;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== categoryColor) {
    t2 = getContrastColor(categoryColor);
    $[3] = categoryColor;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== categoryColor || $[6] !== t2) {
    t3 = {
      backgroundColor: categoryColor,
      color: t2
    };
    $[5] = categoryColor;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== category || $[9] !== t3) {
    t4 = <span className="inline-block px-2 py-1 text-sm rounded-full mb-2 text-center" style={t3}>{category}</span>;
    $[8] = category;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = `/news/${slug}`;
  let t6;
  if ($[11] !== title) {
    t6 = <h2 className="font-semibold mb-2 fluid-md line-clamp-2 text-gray-800 dark:text-gray-100">{title}</h2>;
    $[11] = title;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <Link href={t5}>{t6}</Link>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== excerpt) {
    t8 = <div className="flex flex-grow h-full self-stretch"><p className="text-gray-600 dark:text-gray-300 mb-4 line-clamp-4 text-ellipsis">{excerpt}</p></div>;
    $[16] = excerpt;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t4 || $[19] !== t7 || $[20] !== t8) {
    t9 = <div className="flex flex-col h-full">{t4}{t7}{t8}</div>;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== publishedAt) {
    t10 = publishedAt.toISOString();
    $[22] = publishedAt;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== publishedAt) {
    t11 = publishedAt ?? new Date();
    $[24] = publishedAt;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11) {
    t12 = timeFromNow(t11);
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t12) {
    t13 = <span className="text-sm text-gray-500 dark:text-gray-400"><time dateTime={t10}>{t12}</time></span>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const t14 = `/news/${slug}`;
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ArrowRight className="ml-1 w-4 h-4" />;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t14) {
    t16 = <Link href={t14} className="text-blue-500 hover:text-blue-600 dark:hover:text-blue-400 inline-flex items-center">Read more {t15}</Link>;
    $[32] = t14;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t13 || $[35] !== t16) {
    t17 = <div className="flex justify-between items-center bottom-1 h-full">{t13}{t16}</div>;
    $[34] = t13;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t17 || $[38] !== t9) {
    t18 = <div className="flex flex-col content-center p-4 h-auto flex-grow">{t9}{t17}</div>;
    $[37] = t17;
    $[38] = t9;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t1 || $[41] !== t18) {
    t19 = <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden transition-transform duration-300 hover:scale-105">{t1}{t18}</div>;
    $[40] = t1;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  return t19;
}